import { HttpErrorResponse, HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable, throwError } from 'rxjs'
import { environment } from '../../../environments/environment'
import { MemberModel } from './member.model'

const API_URL = environment.apiUrl

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  constructor(private http: HttpClient) {}

  addMember(member: MemberModel) {
    
    return this.http.post(API_URL + '/Member/CreateMember', member, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateMember(member: MemberModel) {
    
    return this.http.put(API_URL + '/Member/UpdateMember', member, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllMembers(): Observable<MemberModel[]> {
    return this.http.get(API_URL + '/Member/ReadMembers', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),

      catchError((error: any) => {
        

        

        return throwError(() => error);
      }),
    )
  }

  deleteMember(member: MemberModel) {
    
    return this.http
      .delete(API_URL + '/Member/DeleteMember', {
        headers: {},
        body: member,
        withCredentials: true
      })
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
